import BreadCrumb from "@componentsShared/BreadCrumb";
import SubmitButton from "@componentsShared/buts/SubmitButton/SubmitButton";
import PageDesc from "./components/PageDesc/PageDesc";
import RecTrendingCars from "./components/RecTrendingCars/RecTrendingCars";
import PostsContainer from "./components/PostsContainer/PostsContainer";
import stl from "./SingleTrendComponent.module.css";
import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";

const paramsToQueryString = (params) => {
    return Object.keys(params)
        .map((key) => {
            if (!params[key]) return null;
            return `${key}=${params[key]}`;
        })
        .filter(Boolean)
        .join("&");
}

const SingleTrendComponent = (
    {
        trend,
        posts,
        similarItems,
    }) => {
    const {t} = useTranslation(["web_trend"]);
    const {createUrl, navigateTo} = useHelpers()
    posts = posts?.length > 0 ? posts : similarItems?.length > 0 ? similarItems : [];

    return (
        <>
            <div className={stl.ST_container}>
                <BreadCrumb
                    className={stl.brdCrmb}
                    links={[
                        {
                            title: t("سيارة ترند", {ns: "web_common"}),
                            link: createUrl("/trend"),
                        },
                        {
                            title: t(trend?.h1_tag, {
                                ns: "web_common",
                            })
                        }
                    ]}
                />
                <h1>{trend?.h1_tag}</h1>
                <picture>
                    <source
                        media="(min-width: 1025px)"
                        srcSet={trend?.hero_img_desktop}
                    />
                    <source media="(max-width: 1024px)" srcSet={trend?.hero_img_mobile}/>
                    <img
                        src={trend?.hero_img_desktop}
                        alt={trend?.h1_tag}
                        width="1152px"
                        height="350px"
                        loading="eager"
                    />
                </picture>
                <p>{trend?.hero_desc}</p>
                {posts.length === 0 ? null : <PostsContainer
                    posts={posts}
                />}
                <SubmitButton
                    className={`redBtn ${stl.customBtn}`}
                    onClick={() =>
                        navigateTo(`/filters?${paramsToQueryString(trend?.filters)}`)
                    }
                    loading={false}
                >
                    {t("تصفح جميع السيارات", {ns: "web_common"})}
                </SubmitButton>
                {" "}
                <PageDesc content={trend?.page_desc}/>
                {trend?.similar?.length ? (
                    <RecTrendingCars
                        similar={trend?.similar}
                    />
                ) : null}
            </div>
        </>
    );
};

export default SingleTrendComponent;
